import React from 'react'
import styled from 'styled-components'
import { media } from 'src/styles/styled-components'

// ArComponents
import ArHeroHeader from 'src/components/ArHeroHeader/ArHeroHeader'
import ArSeo from 'src/components/ArSeo/ArSeo'

// Data
import DaPageCompanySecurity from 'src/data/PageCompanySecurity'
import ArTextContent from 'src/components/ArTextContent/ArTextContent'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import routesConfig from 'src/routes.config'

const StyledContainer = styled(ArBaseContainer)`
  margin-top: 30px;
  margin-bottom: 30px;
  ${ media.tablet`
    margin-top: 40px;
    margin-bottom: 40px;
  ` }
  ${ media.desktop`
    margin-top: 100px;
    margin-bottom: 130px;
    max-width: 750px;
  ` }
`

class SecurityPage extends React.Component {
  render () {
    return (
      <React.Fragment>
        <ArSeo
          title={DaPageCompanySecurity.metadata.title}
          description={DaPageCompanySecurity.metadata.desc}
          path={routesConfig.company.careers()}
        />

        {(() => {
          const { title } = DaPageCompanySecurity.ArHeroHeader
          return (
            <ArHeroHeader
              variant="company-security"
              title={title}
            />
          )
        })()}

        {(() => {
          const { content } = DaPageCompanySecurity.ArTextContent
          return (
            <StyledContainer>
              <ArTextContent
                content={content}
              />
            </StyledContainer>
          )
        })()}

      </React.Fragment>
    )
  }
}

export default SecurityPage
